import { isMobileSize } from "./common/utils/isMobileSize";

class MobileMenu {
  constructor() {
    this.button = document.querySelector('[aria-label="メイン"] button');
    this.menu = this.button.nextElementSibling;

    //リサイズハンドリング
    window.addEventListener("resize", this.initialize.bind(this));

    //初回アップデート
    this.initialize();
    this.update();
  }

  initialize() {
    if (!isMobileSize()) {
      this.button.removeAttribute("aria-expanded");
      this.button.hidden = true;
      this.menu.hidden = false;
      return;
    }

    this.button.setAttribute("aria-expanded", "false");
    this.button.hidden = false;
    this.menu.hidden = true;
  }

  update() {
    this.button.addEventListener("click", function () {
      // メニューの表示／非表示を切り替える
      const expanded = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", String(!expanded));
      this.nextElementSibling.hidden = expanded;
    });
  }
}

export { MobileMenu };
